import React, { createContext, useContext, useState } from 'react';
import Modal from '../components/Modal';

const ModalContext = createContext();

export const useModal = () => {
  const context = useContext(ModalContext);
  if (!context) {
    throw new Error('useModal must be used within ModalProvider');
  }
  return context;
};

export const ModalProvider = ({ children }) => {
  const [modal, setModal] = useState({
    isOpen: false,
    title: '',
    message: '',
    type: 'info',
    onConfirm: null,
    onCancel: null,
    showCancel: false
  });

  const showModal = ({ title, message, type = 'info', onConfirm = null, onCancel = null, showCancel = false }) => {
    setModal({
      isOpen: true,
      title,
      message,
      type,
      onConfirm,
      onCancel,
      showCancel
    });
  };

  const hideModal = () => {
    setModal(prev => ({ ...prev, isOpen: false }));
  };

  const alert = (message, title = null, type = 'info') => {
    return new Promise((resolve) => {
      showModal({
        title: title || (type === 'error' ? 'Error' : type === 'success' ? 'Success' : 'Information'),
        message,
        type,
        onConfirm: () => {
          resolve();
          hideModal();
        },
        showCancel: false
      });
    });
  };

  const confirm = (message, title = null) => {
    return new Promise((resolve) => {
      showModal({
        title: title || 'Confirm',
        message,
        type: 'confirm',
        onConfirm: () => {
          resolve(true);
          hideModal();
        },
        onCancel: () => {
          resolve(false);
          hideModal();
        },
        showCancel: true
      });
    });
  };

  return (
    <ModalContext.Provider value={{ showModal, hideModal, alert, confirm }}>
      {children}
      <Modal
        isOpen={modal.isOpen}
        onClose={hideModal}
        title={modal.title}
        message={modal.message}
        type={modal.type}
        onConfirm={modal.onConfirm}
        onCancel={modal.onCancel}
        showCancel={modal.showCancel}
      />
    </ModalContext.Provider>
  );
};

